import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';

/**
 * 2520. Board見積金額取得
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/board_amount
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  enabled?: boolean;
};

type QuotationBoardAmountResponse = {
  amount: number;
};

const quotationBoardAmount = (props: Props): Promise<QuotationBoardAmountResponse> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/board_amount`,
    { params: props }
  );
};

export const useQuotationBoardAmount = (props: Props) => {
  return useQuery({
    queryKey: [
      'workspaces',
      props.identifier,
      'team_id',
      props.team_id,
      'sales_order_id',
      props.sales_order_id,
      'board_amount',
    ],
    queryFn: () => quotationBoardAmount(props),
    enabled: props.enabled,
  });
};
